import React, { useEffect, useState } from "react";
// import "./UserManagement.scss";
import { loginScreen, userPlaceholderIcon } from "assets/images";
import { Link, useParams } from "react-router-dom";
import { toastMessage } from "utils/toastMessage";
import useFullPageLoader from "common/UseFullPageLoader";

import { dateFormat } from "utils/dateFormat";
import { CustomModal } from "components/modals/ModalBox";
import { AiOutlineDownload } from "react-icons/ai";
import usePlaceholder from "react-bootstrap/esm/usePlaceholder";
import { userPlaceholder } from "assets/icons";
import { postDetailApi } from "services/post";
import { IoMdArrowRoundBack } from "react-icons/io";
import { eventTime, timeFormat } from "common/InputForm";
import { eventDetailApi } from "services/event";
import { Description } from "@mui/icons-material";

const EventDetail = () => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const { id } = useParams();
  const [formData, setFormData] = useState({});

  const [imagePreview, setImagePreview] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [isJoinEnabled, setIsJoinEnabled] = useState(false);

  useEffect(() => {
    fetchPostDetails(id);
  }, [id]);
  const fetchPostDetails = async () => {
    try {
      const res = await eventDetailApi(id);
      console.log(res.data.data.event, "detail");
      if (res?.status === 200) {
        setFormData({
          eventId: id,
          description: res.data.data.event.description,
          title: res.data.data.event.title,
          image: res.data.data.event.image,
          venue: res.data.data.event.venue,
          meetingLink: res.data.data.event.meetingLink,
          dateTime: res.data.data.event.dateTime,
          mode: res.data.data.event.mode,
          duration: res.data.data.event.duration,
          totalEventSubscribed: res.data.data.totalEventSubscribed,
          type: res.data.data.event.type,
        });
      } else {
        toastMessage(res?.data?.message, "error", "event Detail");
      }
    } catch (e) {
      toastMessage(e.message, "error", "event Detail");
    }
  };
  //------------join-link------------------here-only-5-mint-before-show

  // useEffect(() => {
  //   const checkJoinTime = () => {
  //     const eventTime = new Date(formData?.dateTime);
  //     const currentTime = new Date();

  //     // Calculate difference in minutes
  //     const timeDiff = Math.floor((eventTime - currentTime) / 60000);

  //     // Enable join button if within 5 minutes before the event
  //     setIsJoinEnabled(timeDiff <= 5 && timeDiff >= 0);
  //   };

  //   if (formData?.dateTime) {
  //     checkJoinTime();
  //     const interval = setInterval(checkJoinTime, 1000);
  //     return () => clearInterval(interval);
  //   }
  // }, [formData?.dateTime]);
  //---------here-5-mint-before-show-and-after-that-show---------------
  // useEffect(() => {
  //   const checkJoinTime = () => {
  //     const eventTime = new Date(formData?.dateTime);
  //     const currentTime = new Date();

  //     // Calculate difference in minutes
  //     const timeDiff = Math.floor((eventTime - currentTime) / 60000);

  //     // Enable join button if within 5 minutes before the event or any time after
  //     setIsJoinEnabled(timeDiff <= 5);
  //   };

  //   if (formData?.dateTime) {
  //     checkJoinTime();
  //     const interval = setInterval(checkJoinTime, 1000);
  //     return () => clearInterval(interval);
  //   }
  // }, [formData?.dateTime]);
  //--------------here-duration-time-end-then-disabled-button-----and-enabled-5-mint-before---------------
  useEffect(() => {
    const checkJoinTime = () => {
      const eventTime = new Date(formData?.dateTime);
      const currentTime = new Date();

      // Calculate difference in minutes
      const timeDiff = Math.floor((eventTime - currentTime) / 60000);

      // Calculate event end time (event start time + duration in minutes)
      const eventEndTime = new Date(
        eventTime.getTime() + formData?.duration * 60000
      );

      // Enable join if 5 minutes before start and disable after event ends
      setIsJoinEnabled(timeDiff <= 5 && currentTime <= eventEndTime);
    };

    if (formData?.dateTime && formData?.duration) {
      checkJoinTime();
      const interval = setInterval(checkJoinTime, 1000);
      return () => clearInterval(interval);
    }
  }, [formData?.dateTime, formData?.duration]);

  const handleJoinMeet = (link) => {
    if (!link) {
      toastMessage("Invalid meeting link", "error", "invalidLink");
      return;
    }
    if (isJoinEnabled) {
      window.open(link, "_blank");
    } else {
      toastMessage(
        "You can join only 5 minutes before the event.",
        "error",
        "joinMeting"
      );
    }
  };

  console.log("formData", formData);

  return (
    <>
      {loader}
      <div className="editProfile user_management">
        <div className="dashboard_title">
          <h3>
            <Link to={"/event-management"}>
              <IoMdArrowRoundBack />
            </Link>{" "}
            Event details
          </h3>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="personal_details _box spacing">
              <div className="details_list">
                <ul>
                  <li>
                    <b>Event Title</b>
                    <span>{formData?.title}</span>
                  </li>

                  <li>
                    <b>Time</b>
                    <span> {eventTime(formData?.dateTime)}</span>
                  </li>
                  <li>
                    <b>Date</b>
                    <span> {dateFormat(formData?.dateTime)}</span>
                  </li>
                  <li>
                    <b>Duration (in min)</b>
                    <span>{formData?.duration}</span>
                  </li>
                  {formData.mode == !"online" && (
                    <li>
                      <b>Venue</b>
                      <span>{formData?.venue}</span>
                    </li>
                  )}

                  <li>
                    <b>Mode</b>
                    <span>{formData?.mode}</span>
                  </li>
                  <li>
                    <b>Type</b>
                    <span>{formData?.type}</span>
                  </li>

                  {formData.mode === "online" && (
                    <li>
                      <b>Meeting Link</b>
                      <button
                        className="btn btn-primary"
                        onClick={() => handleJoinMeet(formData?.meetingLink)}
                        disabled={!isJoinEnabled}
                      >
                        Join
                      </button>
                    </li>
                  )}
                  <li>
                    <b>Total subscribe</b>
                    <span>{formData?.totalEventSubscribed ?? 0}</span>
                  </li>

                  <li>
                    <b>Description</b>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: formData?.description,
                      }}
                    />
                  </li>
                </ul>
              </div>
            </div>
            <div className="tab_content">
              <div className="post_details">
                {/* Render  data */}
                <div className="post_item">
                  <div className="image_gallery">
                    <ul className="image_list">
                      <label className="label">Image</label>
                      <li
                        onClick={() => {
                          setImagePreview(true);
                          setImageUrl(formData?.image);
                        }}
                      >
                        <img
                          src={formData?.image ? formData?.image : loginScreen}
                          // alt={`image`}
                          className="post_image"
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        show={imagePreview}
        handleClose={() => setImagePreview(false)}
        className={"image_preview_modal"}
      >
        <img src={imageUrl ? imageUrl : loginScreen} alt="" />
      </CustomModal>
    </>
  );
};

export default EventDetail;
